module.exports = __webpack_public_path__ + "img/Ladies_White.623e3cf9.png";